import React from 'react';

const getIsNation = (ssn2: string): boolean => {
  const secondFirstPlace = ssn2.substring(0, 1);

  switch (secondFirstPlace) {
    case '5':
    case '6':
    case '7':
    case '8':
      return true;
    default:
      return false;
  }
};

export const validateSsnCheck = (_ssn1: string, _ssn2: string, isSsnChanged?: boolean) => {
  const ssn1 = _ssn1,
    ssn2 = _ssn2,
    ssn = ssn1 + '' + ssn2,
    arrSsn: number[] = [],
    compare = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
  let sum = 0;

  if (ssn.length !== 13) return false;

  if (isSsnChanged) {
    return true;
  }

  const secondFirstPlace = ssn2.substring(0, 1);

  if (ssn1 >= '201001' && ['3', '4'].includes(secondFirstPlace)) {
    return true;
  }

  for (let i = 0; i < 13; i++) {
    arrSsn[i] = Number(ssn.substring(i, i + 1));
  }

  for (let i = 0; i < 12; i++) {
    sum = sum + arrSsn[i] * compare[i];
  }

  const isNation = getIsNation(ssn2);
  if (isNation) {
    sum = (13 - (sum % 11)) % 10;
  } else {
    sum = (11 - (sum % 11)) % 10;
  }

  if (sum !== arrSsn[12]) return false;

  return true;
};

export const preventInputEnter = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    return true;
  }
  return false;
};

export const pressEnterNextFocus = (event: React.KeyboardEvent<HTMLInputElement>, nextElement: HTMLElement | null) => {
  const isPrevented = preventInputEnter(event);

  if (!nextElement || !isPrevented) {
    return;
  }

  nextElement.focus();
};

export const checkInputOnlyNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
  const notNumberRegex = /[^0-9]/g;
  const hasNotNumberChar = event.target.value.match(notNumberRegex);

  if (!hasNotNumberChar) {
    return;
  }

  event.target.value = event.target.value.replace(notNumberRegex, '');
};

export const validateNonSpecialPattern = (input: string) => {
  const ALLOWED_PATTERN = /^[a-zA-Z0-9가-힣\s]*$/gi;
  return ALLOWED_PATTERN.test(input);
};
